import { PresetFrame, type PresetArtProps } from './PresetFrame';

export function Cat(props: PresetArtProps) {
  return (
    <PresetFrame background="#0891b2" {...props}>
      <path d="M17 32 V13 L28 23 H36 L47 13 V32 A15 15 0 0 1 17 32 Z" fill="#ffffff" />
      <circle cx="26" cy="34" r="2.5" fill="#1f2937" />
      <circle cx="38" cy="34" r="2.5" fill="#1f2937" />
      <path d="M30 40 H34 L32 42.5 Z" fill="#1f2937" />
    </PresetFrame>
  );
}
